import checkout from "./form";

const {
  formField: {
    fullName,
    signer,
    certificate,
    timeSign,

    taxCalculationPeriod,
    firstTime,
    supplementaryForThe,

    taxpayerName,
    taxpayerCountry,
    taxpayerAddress,

    capitalTransfereeName,
    capitalTransfereeCountry,
    capitalTransfereeAddress,
    capitalTransfereeTaxId,

    taxAgentName,
    taxAgentId,

    enterprisesTransferredName,
    enterprisesTransferredTaxId,

    contractNumber,
    contractDay,
  },
} = checkout;

const initialValues = {
  [fullName.name]: "",
  [signer.name]: "",
  [certificate.name]: "",
  [timeSign.name]: "",

  [firstTime.name]: false,
  [supplementaryForThe.name]: "",
  [taxCalculationPeriod.name]: "",

  [taxpayerName.name]: "",
  [taxpayerCountry.name]: "",
  [taxpayerAddress.name]: "",

  [capitalTransfereeName.name]: "",
  [capitalTransfereeCountry.name]: "",
  [capitalTransfereeAddress.name]: "",
  [capitalTransfereeTaxId.name]: "",

  [taxAgentName.name]: "",
  [taxAgentId.name]: "",

  [enterprisesTransferredName.name]: "",
  [enterprisesTransferredTaxId.name]: "",

  [contractNumber.name]: "",
  [contractDay.name]: "",
};

export default initialValues;
